import api from '@motionelements/core/src/api/base-api-v2';
import loadingMutation from '@motionelements/core/src/store/mutations-mixins/loadingMutation.js';
import { aiModelTypes } from '@motionelements/core/src/helpers/ai-tools.js';

const state = () => ({
  list: [],
  loading: false,
  isLoaded: false,
});

const getters = {
  aiToolsReleased(state) {
    return state.list.filter(({ released }) => released);
  },
  aiToolModelType() {
    // eslint-disable-next-line
    return (toolId) => {
      // eslint-disable-next-line
      return aiModelTypes.filter((modelType) => {
        return modelType.tools.includes(toolId);
      });
    };
  },
};

const actions = {
  async getAiTools({ commit }, params) {
    commit('setLoading', true);
    return api.get('/v3/tools', { params })
      .then((response) => {
        commit('setAiTools', response.data.data);
        commit('setIsLoaded', true);
      })
      .catch(err => {
        console.error(err);
      })
      .finally(() => {
        commit('setLoading', false);
      });
  },
};

const mutations = {
  setAiTools(state, array) {
    state.list = array;
  },
  setIsLoaded(state, boolean) {
    state.isLoaded = boolean;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations: {
    ...mutations,
    ...loadingMutation,
  },
};
